// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"ArwKhtxA","secondary":"EjbKpRek","styledButton":"f3mmr_LF","prev":"vDPBHY3F","next":"F_MLHi8B","tabButton":"scb_HCPn","active":"mbOw_avb"};